__turbopack_context__.v({
  "contactInfo": "footer-module__sBkBiW__contactInfo",
  "content": "footer-module__sBkBiW__content",
  "footer": "footer-module__sBkBiW__footer",
  "infoWrapper": "footer-module__sBkBiW__infoWrapper",
  "isMobile": "footer-module__sBkBiW__isMobile",
  "legalInfo": "footer-module__sBkBiW__legalInfo",
  "logo": "footer-module__sBkBiW__logo",
  "logoImage": "footer-module__sBkBiW__logoImage",
  "menuItems": "footer-module__sBkBiW__menuItems",
  "wrapper": "footer-module__sBkBiW__wrapper",
});
